// extracted by mini-css-extract-plugin
export default {"actions":"product-table-row_actions__cXhrt","last-row":"product-table-row_last-row__DUNji","wrapProductTableRow":"product-table-row_wrapProductTableRow__Mn3YS"};